import * as GLOBALS from '@/globals';

// Vue and Application
import Vue from 'vue';
import App from '@/App.vue';

// Router
import router from '@/router';

// Vuex Data Store
import store from '@/store';

// Service Worker
import '@/registerServiceWorker';

// API
import { Client, RecipientTypes, Topics, Content, Saves, Pages } from 'nat-hiu-api-client';
const client = new Client({
	endpoint: process.env.VUE_APP_BACKEND_ENDPOINT
});

// Content
import BuilderPlugin from 'rd-vue-block-builder';
Vue.use(BuilderPlugin, {
    store: store
});

// Clipboard
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

// Vue Configuration
// https://vuejs.org/v2/api/#productionTip
Vue.config.productionTip = false;

// Set globals
Vue.prototype.$GLOBALS = GLOBALS;
Vue.prototype.$eventBus = new Vue();
Vue.prototype.$recipientTypes = new RecipientTypes(client);
Vue.prototype.$topics = new Topics(client);
Vue.prototype.$content = new Content(client);
Vue.prototype.$saves = new Saves(client);
Vue.prototype.$pages = new Pages(client);

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');